import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem } from 'primeng/api';
import { Card } from '../../../models/loyalty-card.model';
import { CalendarTranslateService } from '../../../modules/UIKit/services/calendarTranslate.service';
import { DivisionSalesNetworkService } from '../../../services/division-sales-network/divison-sales-network.service';
import { LoyaltyAcmService } from '../../../services/loyalty/loyalty-acm.service';
import { LoyaltyReasonService } from '../../../services/loyalty/reason.service';
import { StoreCommonService } from '../../../services/store/store-common.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'kv-loyalty-account-balance-filter',
  templateUrl: 'loyalty-account-balance-filter.component.html',
  styles: [`
      .card .search-toolbar-input {
        display: flex;
        align-items: baseline;
      }
      label.required:after {
        top: 0
      }
  `]
})
export class LoyaltyAccountBalanceFilterComponent implements OnInit {

  @Input() customerMgPermission: boolean;
  @Output() onApply: EventEmitter<any> = new EventEmitter();
  @Input() movementExportExcelPermission: boolean;

  divisionSaleNetworkItems: SelectItem[];
  storeItems: SelectItem[];
  acmItems: SelectItem[];

  reasonItems: SelectItem[];
  showSearchCard = false;
  showAcmSelecterd = true;
  searchForm: FormGroup;
  calendarTranslate: any;
  dateStartIssue = false;
  dateEndIssue = false;
  dateStartMax = null;
  dateEndMin = null;
  maxChars: number;
  optionSelectlabel: string;
  userID: string;

  showExpiredAcm: boolean = false;
  visibleAcmItems: SelectItem[];
  allLabel: string = '';
  filteredAcmItems: SelectItem[];


  constructor(
    private svcDivisionSalesNetwork: DivisionSalesNetworkService,
    private svcStores: StoreCommonService,
    private fb: FormBuilder,
    private svcCalendar: CalendarTranslateService,
    private translate: TranslateService,
    private svcAcm: LoyaltyAcmService,
    private svcReason: LoyaltyReasonService
  ) {

    this.maxChars = +sessionStorage.getItem('cardsLength');
    // 'name': new FormControl(this.editingElement.name, Validators.compose([Validators.required, Validators.maxLength(100)])),

    this.svcCalendar.pCalendar.subscribe(cal => {
      this.calendarTranslate = cal;
    })

    //valutare se eliminare controlli di lunghezza per il campo cliente
    this.searchForm = this.fb.group({
      'dsn': new FormControl(null),
      'store': new FormControl(null),
      'customer': new FormControl(null),
      'acm': new FormControl(null),
      'date_start': new FormControl(null),
      'date_end': new FormControl(null),
      'reason': new FormControl(null),
      'exclude_reason': new FormControl(null),
      'customer_id': new FormControl(null)
    }
    )

  }

  ngOnChanges(changes: SimpleChanges): void {

  }

  ngOnInit(): void {


    this.searchForm = this.fb.group({
      dsn: [null], // Division Sales Network
      store: [null], // Store
      customer: [{ value: '', disabled: true }], // Disabilita qui
      acm: [null], // Accumulatore
      reason: [null], // Reason
      exclude_reason: [false], // Exclude Reason
      date_start: [null, Validators.required], // Start Date
      date_end: [null, Validators.required],
      customer_id: [null, Validators.required]
    });

    this.translate.get(['common.all']).subscribe(t => {
      this.divisionSaleNetworkItems = [{
        value: null,
        label: t['common.all']
      }]

      this.storeItems = []
      //KS-6887 lasciare per gli utenti amministratori la voce ‘Tutti’, ma di renderla invece non visibile per le utenze di negozio
      this.translate.get(['common.select', 'common.all']).subscribe(tr => {
        this.allLabel = this.movementExportExcelPermission ? tr['common.all'] : tr['common.select'];

        this.acmItems = [{
          value: null,
          label: this.allLabel
        }];
        this.filteredAcmItems = [{
          value: null,
          label: this.allLabel
        }];
        this.visibleAcmItems = [{
          value: null,
          label: this.allLabel
        }];

        this.showAcmSelecterd = this.movementExportExcelPermission;


      });

      this.reasonItems = []
      //TODO: KS.7037

      const userDataString = sessionStorage.getItem('userData');

      if (!userDataString) {
        console.warn('Nessun userData trovato in sessionStorage');
        return;
      }

      try {
        const userData = JSON.parse(userDataString);

        if (userData && userData.id) {
          this.userID = userData.id.toString();
        } else {
          console.error('ID utente non valido:', userData);
          return;
        }
      } catch (error) {
        console.error('Errore nel parsing di userData:', error);
        return;
      }
      this.svcDivisionSalesNetwork.getStoreDivisionUser(this.userID).subscribe({
        next: (dsn_list) => {
          this.divisionSaleNetworkItems = [
            { value: null, label: '' },
            ...dsn_list.map(dsn => ({
              value: dsn.division_sales_network_id,
              label: `${dsn.division_name} - ${dsn.sales_network_name}`
            }))
          ];
        },
        error: (err) => {
          console.error('Errore nella chiamata getListExpanded2:', err);
        }
      });





      /* 
            this.svcDivisionSalesNetwork.getListExpanded().subscribe(dsn_list => {
              dsn_list.forEach(dsn => {
             
                this.divisionSaleNetworkItems.push({
                  value: dsn.id,
                  label: dsn.division_name + ' - ' + dsn.sales_network_name
                })
              })
           
            })
           */
      this.svcReason.listPointReason().subscribe(reasonList => {
        reasonList.data.forEach(r => {
          this.reasonItems.push({
            value: r.id,
            label: r.reason_code + ' - ' + r.description
          })
        })
      })

      /*      this.svcAcm.list(null, null, [{ key: 'acmVisible', value: '0' }, { key: 'flg_state', value: '0' }]).subscribe(acmList => {
              acmList.data.forEach(acm => {
                this.acmItems.push({
                  value: this.customerMgPermission ? acm.acm_code : acm.id,
                  label: acm.acm_code + ' - ' + acm.acmDescription
                })
              })
            })*/
    })

    this.searchForm.controls['customer']
      .valueChanges
      .debounceTime(1000)
      .subscribe(value => {
        console.log('debouncing')
      })
    //this.showAcmSelecterd = true;
  }




  onDivisionSalesNetworkChange(data: SelectItem) {
    const dsnId = data.value;

    this.svcStores.getList(null, null, {
      division_sales_network: dsnId
    }).subscribe(stores => {
      this.storeItems = stores.map(s => ({
        value: s.id,
        label: s.code + ' - ' + s.name
      }));
    });
  }

//incluso anche chackboxparameter
search(data) {
  const fullSearchValues = {
    ...this.searchForm.value,
    showExpiredAcm: this.showExpiredAcm
  };
  console.log(fullSearchValues);
  this.onApply.emit(fullSearchValues);
}


  onOpenSelectCard() {
    this.showSearchCard = true;
  }

  onCardSelect(data: Card) {
    let idDescription = data.vCustomerId && data.customerDescription
      ? data.vCustomerId + ' - ' + data.customerDescription
      : data.vCustomerId || data.customerDescription || '';


    this.searchForm = this.fb.group({
      'dsn': new FormControl(this.searchForm.value.dsn),
      'store': new FormControl(this.searchForm.value.store),
      'customer': new FormControl(idDescription),
      'acm': new FormControl(this.searchForm.value.acm),
      'date_start': new FormControl(this.searchForm.value.date_start),
      'date_end': new FormControl(this.searchForm.value.date_end),
      'reason': new FormControl(this.searchForm.value.reason),
      'exclude_reason': new FormControl(this.searchForm.value.exclude_reason),
      'customer_id': new FormControl(data.vCustomerId)
    }
    )
    this.showSearchCard = false;
    this.showAcmSelecterd = false;
    const searchParams = [

      { key: "customer_id", value: data.vCustomerId },

    ];
    //TODO: devo cambiare la chiamata
    //KS-6867: rimozione di select in caso di utente senza permessi per download excell
    this.svcAcm.getAcmListFromBalance(searchParams).subscribe(acmList => {
      this.acmItems = [];
      this.filteredAcmItems = [];

      // Push label "All"
      const translatedAll = this.translate.instant('common.all');
      const defaultItem = { value: null, label: translatedAll };

      this.acmItems.push(defaultItem);
      this.filteredAcmItems.push(defaultItem);

      acmList.forEach(acm => {
        const item = {
          value: this.customerMgPermission ? acm.acm_code : acm.id,
          label: acm.acm_code + ' - ' + acm.acmDescription
        };
        this.acmItems.push(item);
        if (acm.status === 'valid') {
          this.filteredAcmItems.push(item);
        }
      });

      // Rebuild form with default acm value (first visible)
      const selectedAcm = this.filteredAcmItems.length ? this.filteredAcmItems[0].value : null;
      this.searchForm = this.fb.group({
        'dsn': new FormControl(this.searchForm.value.dsn),
        'store': new FormControl(this.searchForm.value.store),
        'customer': new FormControl(idDescription),
        'acm': new FormControl(selectedAcm),
        'date_start': new FormControl(this.searchForm.value.date_start),
        'date_end': new FormControl(this.searchForm.value.date_end),
        'reason': new FormControl(this.searchForm.value.reason),
        'exclude_reason': new FormControl(this.searchForm.value.exclude_reason),
        'customer_id': new FormControl(data.vCustomerId)
      });

      // At the end — ensure visibility and list correctness
      this.filterAcmList();
    });

  }

  onExpiredCheckboxChange(event: any) {
    this.showExpiredAcm = event;
    this.filterAcmList();
  }

  filterAcmList() {
    console.log(this.showExpiredAcm);
    this.visibleAcmItems = this.showExpiredAcm ? this.acmItems : this.filteredAcmItems;
  }


  resetFilters() {
    this.searchForm = this.fb.group({
      'dsn': new FormControl(null),
      'store': new FormControl(null),
      'customer': new FormControl(null),
      'acm': new FormControl(null),
      'date_start': new FormControl(null),
      'date_end': new FormControl(null),
      'reason': new FormControl(null),
      'exclude_reason': new FormControl(null),
      'customer_id': new FormControl(null)
    })
    this.showAcmSelecterd = true;
    this.translate.get(['common.select', 'common.all']).subscribe(tr => {
      this.acmItems = [{
        value: null,
        label: this.movementExportExcelPermission ? tr['common.all'] : tr['common.select']
      }]
      this.filteredAcmItems = [{
        value: null,
        label: this.movementExportExcelPermission ? tr['common.all'] : tr['common.select']
      }]
      this.visibleAcmItems = [{
        value: null,
        label: this.movementExportExcelPermission ? tr['common.all'] : tr['common.select']
      }]
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-account-balance/loyalty-account-balance-filter.component.ts